import React from "react";
import { useField, useFormikContext } from "formik";
import { StateDropdown, StateDropdownProps } from "@app.automotus.io/components/StateDropdownField";
import { StateAbbreviation } from "@app.automotus.io/components/common";

export interface StateDropdownFormikFieldProps
  extends Omit<StateDropdownProps, "value" | "onChange" | "onBlur" | "error" | "helperText"> {
  name: string;
}

/**
 * Formik-integrated wrapper for StateDropdown.
 * Connects the StateDropdown to Formik state management.
 */
export const StateDropdownFormikField: React.FC<StateDropdownFormikFieldProps> = ({ name, disabled, ...rest }) => {
  const { isSubmitting } = useFormikContext();
  const [field, meta, helpers] = useField<StateAbbreviation | null>(name);

  const showError = meta.touched && !!meta.error;

  return (
    <StateDropdown
      {...rest}
      value={field.value}
      onChange={(_, value) => helpers.setValue(value)}
      onBlur={() => helpers.setTouched(true)}
      disabled={disabled ?? isSubmitting}
      error={showError}
      helperText={showError ? meta.error : undefined}
      fullWidth
      disablePortal
    />
  );
};

export default StateDropdownFormikField;
